module.exports = __webpack_public_path__ + "img/unsplash_f1WMJR8pLqo_circle.7d1f1d2e.png";